<div cdkDrag cdkDragRootElement=".cdk-overlay-pane">
<label class="style3 calibriFont FinTitle" id="example-radio-group-label">{{getSingleTextLabel('5019')}}</label><br><br>
<div style="display: flex;justify-content: space-between;">
  <mat-radio-group [(ngModel)]="optionSelected" (change)='changeOption($event)'>
    <mat-radio-button class="style2a calibriFont" *ngFor="let cycle of auxArray" [value]="'month'+cycle">{{getSingleTextLabel('5013')}} {{cycle}} &nbsp;&nbsp;</mat-radio-button>
    <mat-radio-button class="style2a calibriFont" value="ratio">{{getSingleTextLabel('7009')}}</mat-radio-button>
  </mat-radio-group>
   <button  (click)="changeOption($event)" *ngIf="optionSelected != 'ratio'" class="btn btn2 btn-primary">
            Refresh
        </button>
</div>


<ng-container *ngIf="optionSelected == 'ratio'">
  <app-result-ratios></app-result-ratios>
</ng-container>


  <div *ngIf="blnShowtable && optionSelected !== 'ratio'">

  <!-- ================= HEADER DINÁMICO ================= -->
  <table mat-table [dataSource]="dataSource" class="mat-elevation-z2 w-100">

    <!-- ================= COLUMNA LABEL ================= -->
    <ng-container matColumnDef="label">
      <th mat-header-cell *matHeaderCellDef></th>

      <td mat-cell
          *matCellDef="let row"
          class="row-label">
        {{ row.label }}
      </td>
    </ng-container>

    <!-- ================= COLUMNAS POR TEAM ================= -->
    <ng-container *ngFor="let team of lstTeams; let i = index"
                  [matColumnDef]="'team' + i">

      <th mat-header-cell
          *matHeaderCellDef
          class="mat-header-cell text-center calibriFont"
          [ngStyle]="{
            'background-color': team.Color,
            'color': team.Color === '#ffe998'
                  || team.Color === '#84eeeb'
                  || team.Color === '#bec3ff'
                  || team.Color === undefined
                  || team.Color === '#e4e4ec'
                  || team.Color === '#7faeff'
                  ? 'black' : 'white'
          }">
        {{ team.Avatar }}
      </th>

      <td mat-cell
          *matCellDef="let row"
          class="mat-cell style5b border calibriFont"
          style="cursor:pointer"
          [id]="row.type + i"
          (click)="fnClickSelect(row.type, i)"
          [style.color]="row.colorFn ? row.colorFn({ index: i }) : null">

        {{ row.valueFn(row, i) }}

      </td>

    </ng-container>

    <!-- ================= HEADER ================= -->
    <tr mat-header-row
        *matHeaderRowDef="displayedColumns">
    </tr>

    <!-- ================= ROWS ================= -->
    <tr mat-row
        *matRowDef="let row; columns: displayedColumns"
        [ngClass]="row.rowClass">
    </tr>

  </table>

  <hr>

  <!-- ================= SELECT MONTH 3 ================= -->
  <table class="w-100 compact-table" *ngIf="optionSelected === 'month3'">
    <tr>
      <th class="compact-label">
        {{ getSingleTextLabel('5007') }}:
      </th>

      <td *ngFor="let item of lstSelects">
        <mat-form-field appearance="fill" class="w-100 compact-field">
          <mat-label>{{ getSingleTextLabel('137') }}</mat-label>

          <mat-select
            [(ngModel)]="item.text"
            [disabled]="!blnFacilitador"
            (selectionChange)="changeSelect()">

            <mat-option value="opex">{{ getSingleTextLabel('7168') }}</mat-option>
            <mat-option value="capex">{{ getSingleTextLabel('7') }}</mat-option>
            <mat-option value="both">{{ getSingleTextLabel('5020') }}</mat-option>

          </mat-select>
        </mat-form-field>
      </td>
    </tr>
  </table>

  <!-- ================= TEXTAREAS ================= -->
  <table class="w-100 compact-table">
    <tr *ngFor="let item of lstTextArea">

      <th class="compact-label">
        <mat-form-field appearance="fill" class="w-100 compact-field">
          <textarea
            matInput
            rows="2"
            [disabled]="!blnFacilitador"
            [(ngModel)]="item[0].text"
            (change)="changeTextArea()">
          </textarea>
        </mat-form-field>
      </th>

      <td *ngFor="let textArea of item; let i = index"
          [hidden]="i === 0">

        <mat-form-field appearance="fill" class="compact-field">
          <textarea
            matInput
            rows="2"
            [disabled]="!blnFacilitador"
            [(ngModel)]="textArea.text"
            (change)="changeTextArea()">
          </textarea>
        </mat-form-field>
      </td>

    </tr>
  </table>

</div>



  <!-- <div class="container" *ngIf="blnShowtable && optionSelected != 'ratio'">
    <div class="row" *ngIf="optionSelected == 'month3'">
      <div class="col-2 w-100">
        <p>OpEx or CapEx</p>
      </div>
      <div class="col-2 w-100" *ngFor="let item of lstSelects">
        <mat-form-field class="w-100" appearance="fill">
          <mat-label>Select</mat-label>
          <mat-select [disabled]="!blnFacilitador" (selectionChange)="changeSelect()" [(ngModel)]="item.text" >
            <mat-option value="opex">OpEx</mat-option>
            <mat-option value="capex">CapEx</mat-option>
            <mat-option value="both">Both</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col-2" *ngFor="let textArea of lstTextArea">
        <mat-form-field  class="w-100" appearance="fill">
          <textarea class="textAreaFormField" [disabled]="!blnFacilitador" (change)="changeTextArea()" [id]="textArea.idtextAreaReports1" name="notes" rows="10" matInput  cols="17" rows="3" [(ngModel)]="textArea.text" >{{textArea.text}}</textarea>
        </mat-form-field>
      </div>
    </div>
  </div> -->

</div>